import { FormControl as MuiFormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { Property } from 'types';
import { FormControl } from './Controls/FormControl';
import { Location } from 'types/Location';

export type MultiEditFormProps = {
    item?: MultiEditItemType;
    properties: Property[];
    tagOptions?: string[];
    onChange?: (newValue: MultiEditItemType) => void;
};

export type MultiEditItemType = {
    property?: string,
    value?: string | number | Date | boolean | Location
}

export function MultiEditForm({ item, properties, tagOptions, onChange }: MultiEditFormProps) {

    const property = useMemo(() => {
        let property = properties.find(p => p.name === item?.property);
        if (!property)
            return undefined;

        return {
            ...property,
            displayName: "Value"
        };
    }, [properties, item?.property]);

    const isSpatial = property?.type === 'spatial';

    return <Stack direction={isSpatial ? "column" : "row"} gap={2} alignItems="stretch">
        <MuiFormControl fullWidth size="small" >
            <InputLabel id="property-select-label">Property</InputLabel>
            <Select
                labelId="property-select-label"
                id="property-select"
                value={item?.property}
                label="Property"
                onChange={e => {
                    onChange({ property: e.target.value as string });
                }}
            >
                <MenuItem disabled value="">
                    <em>Select a property</em>
                </MenuItem>
                {(properties || [])
                    .filter(x => !x.readOnly && !x.hidden)
                    .map((x, i) => <MenuItem
                        key={i}
                        value={x.name}
                    >
                        {x.displayName || x.name}
                    </MenuItem>
                    )}
            </Select>
        </MuiFormControl>

        {item?.property && <FormControl
            value={item?.value}
            property={property}
            tagOptions={tagOptions}
            onChange={x => onChange({
                ...item,
                value: x
            })}
        />}
    </Stack>
}